import { ChangeDetectorRef, Component, EventEmitter, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AvantorDialogsService } from '@shared/dialogs/avantor-dialogs-api';
import { MaterialsModule } from '@shared/materials.module';

@Component({
  selector: 'app-responsive-enterprise-popup',
  templateUrl: './responsive-enterprise-popup.html',
  styleUrls: ['./responsive-enterprise-popup.scss'],
  standalone: true,
  imports: [CommonModule, MaterialsModule],
})
export class ResponsiveEnterprisePopupComponent implements OnInit {

  @Output() closePanel = new EventEmitter<void>();

  constructor(
    private avantorDialogs: AvantorDialogsService,
    private changeDetectorRef: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
  }

  openEnterpriseDialog() {
    this.avantorDialogs.openEnterpriseDialog();
  }

  close() {
    this.closePanel.emit();
  }

}
